export function findDeep<T extends any = any>(
  object: any,
  predicate: { (item: T): boolean }
): T[] {
  const results: T[] = []

  if (object === null) {
    return results
  }

  if (typeof object === "object") {
    if (predicate(object)) {
      results.push(object)
    }

    Object.values(object).forEach((value) => {
      results.push(...findDeep<T>(value, predicate))
    })
  } else if (Array.isArray(object)) {
    object.forEach((value) => {
      results.push(...findDeep<T>(value, predicate))
    })
  }

  return results
}
